// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__13v1p","dragIcon":"SortableItem_dragIcon__1qrDj","disabled":"SortableItem_disabled__R_pC-"};